<div class="wrapper">
  <app-page-info
    [resourceName]="'Рука на пульсе'"
    [loginAndRoles]="loginAndRoles"
  />
  @if (tableColumnParams) {
    <div class="filters-container">
      <app-records-table-filters
        [filtersParams]="tableColumnParams!.fields"
        [resourceParams]="resourceParams"
        (filtersChanged)="handleFiltersChange($event)"
      />
    </div>
  }
  <div class="table-wrapper">
    @if (tableColumnParams && tableData) {
      <div class="groups">
        @for (group of groups; track $index) {
          <div class="group">
            <div class="group-name">{{ group.name }}</div>
            <div class="header-columns">
              @for (column of getColumnsForGroup(group, tableColumnParams.fields!); track column.key) {
                <div
                  class="column"
                  [style]="getWidthStylesForColumn(column)"
                >
                  {{ column.name }}
                </div>
              }
            </div>

            <div class="rows">
              @for (row of tableData.content; track row.id) {
                @if (row['isOpen']) {
                  <div
                    class="row-container"
                    @smoothShowHideHeight
                  >
                    <div
                      class="row"
                      [style.background-color]="getRowColor(row.rowColor)"
                      [class]="{
                        'reviewer-row': isReviewer(row),
                        'pointer-cursor': getManagersForCurrentReviewer(row).length
                      }"
                      (click)="handleRowClick(row)"
                    >
                      @for (column of getColumnsForGroup(group, tableColumnParams.fields!); track column.key) {
                        <div
                          class="row-column"
                          [style]="getWidthStylesForColumn(column)"
                        >
                          <app-record-table-items-list
                            [columnParam]="column"
                            [record]="row"
                            [resourceParams]="resourceParams"
                          />
                        </div>
                      }
                    </div>
                    @if (reviewersDisplayingState[+row.id] === false) {
                      <div
                        class="open"
                        @smoothShowHideHeight
                      >
                        <button class="open-manager-list-button">
                          <i class="arrow-icon"></i>
                        </button>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
